import { Model, View } from '@lernetz/ts-lib';
import { PopupContainer } from '../popup-container/PopupContainer';

import {Quiz } from './Quiz';

import template from './QuizLauncherButton.html';


export class QuizLauncherButton extends Model {

    public readonly marginTop: string;
    public readonly marginBottom: string;

    public constructor(public readonly quiz: Quiz, private readonly popupContainer: PopupContainer, props?: object) {
        super({ marginTop: '', marginBottom: '', ...props });
    }

    public showQuiz(): void {
        this.popupContainer.show(this.quiz);
        const subscription = this.quiz.close.subscribe(() => {
            this.popupContainer.close();
            subscription.unsubscribe();
        });
    }
}

export class QuizLauncherButtonView extends View<QuizLauncherButton> {

    constructor() {
        super({ template });
    }
}
